import { createSlice } from "@reduxjs/toolkit";

export interface IAppSettings {
  app_status: string;
  online_shop: string;
  pos_shop: string;
  presence_hop: string;
  have_discount: string;
  Discount_value: number;
  welcome_message: string;
  location_delivery: number;
  is_open: {
    isActive: boolean;
    isInWorkHour: boolean;
    message: string;
    now: string;
    status: boolean;
  };
  shifts: {
    shift_one: {
      start: string;
      end: string;
    };
    shift_two: {
      start: string;
      end: string;
    };
  };
}
export interface IDistrict {
  active: number;
  cost: number;
  id: number;
  name: string;
}
export interface AppState {
  showFoodDetailModal: boolean;
  isOutOfServiceTime: boolean;
  isAppOutOfService: boolean;
  showOutOfServiceModal: boolean;
  showWelcomeMessageModal: boolean;
  selectedFood: any;
  appSettings: IAppSettings;
  districts: IDistrict[];
}

const initialState: AppState = {
  showFoodDetailModal: false,
  showOutOfServiceModal: false,
  isOutOfServiceTime: false,
  isAppOutOfService: false,
  showWelcomeMessageModal: false,
  selectedFood: {},
  appSettings: {
    app_status: "0",
    online_shop: "0",
    pos_shop: "0",
    presence_hop: "0",
    have_discount: "0",
    Discount_value: 0,
    welcome_message: "",
    location_delivery: 0,
    is_open: {
      isActive: false,
      isInWorkHour: false,
      message: "",
      now: "",
      status: false,
    },
    shifts: {
      shift_one: {
        start: "0",
        end: "0",
      },
      shift_two: {
        start: "0",
        end: "0",
      },
    },
  },
  districts: [],
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    toggleFoodDetailModal: (state) => {
      state.showFoodDetailModal = !state.showFoodDetailModal;
    },

    toggleOutOfServiceModal: (state) => {
      state.showOutOfServiceModal = !state.showOutOfServiceModal;
    },
    toggleWelcomeMessageModal: (state) => {
      state.showWelcomeMessageModal = !state.showWelcomeMessageModal;
    },
    setSelectedFood: (state, action) => {
      state.selectedFood = action.payload;
    },
    setAppOutOfService: (state, action) => {
      state.isAppOutOfService = action.payload;
    },
    setOutOfServiceTime: (state, action) => {
      state.isOutOfServiceTime = action.payload;
    },
    setAppSettings: (state, action) => {
      state.appSettings = action.payload;
    },
    setDistricts: (state, action) => {
      state.districts = action.payload;
    },
  },
});

export const {
  toggleFoodDetailModal,
  toggleOutOfServiceModal,
  toggleWelcomeMessageModal,
  setSelectedFood,
  setAppSettings,
  setAppOutOfService,
  setOutOfServiceTime,
} = appSlice.actions;

export default appSlice.reducer;
